import React from 'react'
import AddCircleIcon from '@material-ui/icons/AddCircle';
import Grid from "@material-ui/core/Grid";
import {Avatar} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const styles={
    textStyle:{
        textAlign:"left",
        paddingLeft:"10px"
    },
    avatarStyle:{
        backgroundColor:"#2e5790",
        height: '20px',
        width: '20px',
        fontSize:"13px"
    }



}
function MFATextContainer(props){
    const classes= props.classes;
    return(
        <Grid container wrap={"nowrap"}>
            <Grid item>
                <Avatar className={classes.avatarStyle}>{props.number}</Avatar>
            </Grid>
            <Grid item  className={classes.textStyle}>
                {props.text}
            </Grid>
        </Grid>
    )
}


export default withStyles(styles)(MFATextContainer);